import { Component, inject, OnInit } from '@angular/core';
import {
  IonApp,
  IonRouterOutlet,
  IonSpinner,
  IonLoading,
  LoadingController,
} from '@ionic/angular/standalone';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { environment } from 'src/environments/environment';
import { AccountService } from './core/services/account.service';
import { Router } from '@angular/router';
import { MenuItems } from './core/data/menu';
import { AppThemeService } from './core/services/apptheme.service';
import { CommonModule } from '@angular/common';
import { Modal } from './core/helpers/modal.helper';
import { ModalService } from './core/services/modal.service';
import { LoadingService2 } from './core/services/loading2.service';
import { AlertService2 } from './core/services/alert2.service';
import { Loading } from './core/helpers/loading.helper';
import { Alert } from './core/helpers/alert.helper';
import { AlertComponent } from './components/alert/alert.component';
import { ModalComponent } from './components/modal/modal.component';
import { LoadingModalComponent } from './components/loading-modal/loading-modal.component';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  standalone: true,
  imports: [
    CommonModule,
    IonApp,
    AlertComponent,
    ModalComponent,
    LoadingModalComponent,
    IonRouterOutlet,
  ],
})
export class AppComponent implements OnInit {
  idleState = 'NOT_IDLE';
  themeLoading = false;
  constructor(
    private idle: Idle,
    private accountS: AccountService,
    private route: Router,

    private modalService: ModalService,
    private loadingService: LoadingService2,
    private alertService: AlertService2
  ) {
    Modal.registerService(this.modalService); // Register once
    Loading.registerService(this.loadingService); // Register once
    Alert.registerService(this.alertService); // Register once

    // set idle parameters
    idle.setIdle(environment.idleTimeAllowed);
    idle.setTimeout(environment.idleTimeout);
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    // detect when the user becomes idle
    idle.onIdleStart.subscribe(() => {
      this.idleState = 'IDLE';
    });

    // fire warning as the timeout countdown approaches end
    this.idle.onTimeoutWarning.subscribe((secondsLeft: number) => {
      // Update the warning message
    });

    // when the user has timed out
    idle.onTimeout.subscribe(() => {
      const url = this.route.url;
      const isDashRoute = MenuItems.find((m) => url.includes(m.route));

      if (isDashRoute && this.accountS.isLoggedIn) {
        this.idleState = 'TIMED_OUT';
        //  this.accountS.logout();
      }
    });
  }
  ngOnInit(): void {
    this.idle.watch();
  }
}
